import { collectionColumnService } from "../services/collectionColumn.service";

export const collectionColumn = {
  namespaced: true,
  state: {
    collectionColumnsByTableName: []
  },
  actions: {
    getCollectionColumnsByTableName({ commit }, tableName) {
      collectionColumnService.getCollectionColumnsByTableName(tableName).then(collectionColumnsByTableName => {
        commit("setCollectionColumnsByTableName", collectionColumnsByTableName);
      });
    },
  },
  mutations: {
    setCollectionColumnsByTableName(state, collectionColumnsByTableName) {
      state.collectionColumnsByTableName = collectionColumnsByTableName;
    }
  }
};